exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".recommendedOps--container--11ON6rqE {\r\n  margin: 0 auto;\r\n  width: 96%;\r\n}\r\n\r\n.recommendedOps--featureTitle--29XX0YEX {\r\n  padding-left: 10px;\r\n  color: #5B6770;\r\n  margin: 0;\r\n}\r\n\r\n.recommendedOps--grid--375uxaKz {\r\n  padding-left: 8px;\r\n  padding-right: 8px;\r\n}\r\n\r\n.recommendedOps--blueHeader--u-08mjvR {\r\n  padding-left: 12px;\r\n  color: #0072CE;\r\n  margin-top: 0;\r\n}", "", {"version":3,"sources":["C:/Users/mhaf3/ss/SeekerV2/src/components/opportunity/recommendedOps/recommendedOps.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,WAAW;CACZ;;AAED;EACE,mBAAmB;EACnB,eAAe;EACf,UAAU;CACX;;AAED;EACE,kBAAkB;EAClB,mBAAmB;CACpB;;AAED;EACE,mBAAmB;EACnB,eAAe;EACf,cAAc;CACf","file":"recommendedOps.css","sourcesContent":[".container {\r\n  margin: 0 auto;\r\n  width: 96%;\r\n}\r\n\r\n.featureTitle {\r\n  padding-left: 10px;\r\n  color: #5B6770;\r\n  margin: 0;\r\n}\r\n\r\n.grid {\r\n  padding-left: 8px;\r\n  padding-right: 8px;\r\n}\r\n\r\n.blueHeader {\r\n  padding-left: 12px;\r\n  color: #0072CE;\r\n  margin-top: 0;\r\n}"],"sourceRoot":""}]);

// exports
exports.locals = {
	"container": "recommendedOps--container--11ON6rqE",
	"featureTitle": "recommendedOps--featureTitle--29XX0YEX",
	"grid": "recommendedOps--grid--375uxaKz",
	"blueHeader": "recommendedOps--blueHeader--u-08mjvR"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"modules":true,"sourceMap":true,"importLoaders":1,"localIdentName":"[name]--[local]--[hash:base64:8]"}!./src/components/opportunity/recommendedOps/recommendedOps.css
// module id = 394
// module chunks = 0